// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import EmptyItem from "./empty_item/EmptyItem";
import Item from "./item/Item";
import { Product } from "#/common/interfaces/conversionworld/Product";
import { Api } from "#/api";
@Component({
  mixins: [template],
  components: {
    EmptyItem,
    Item,
  },
})
export default class Comparison extends Vue {
  @Prop()
  currentProduct?: Product;

  @Prop({
    default: () => {
      return {};
    },
  })
  translation!: object;

  showCurrentProduct = true;

  mounted() {
    window.addEventListener("click", this.handleCloseMobile);
    this.checkProducts();
  }

  beforeDestroy() {
    window.removeEventListener("click", this.handleCloseMobile);
  }

  get products() {
    return this.$store.conversionWorld.compareProducts;
  }
  @Watch("products")
  private checkProducts() {
    if (this.currentProduct) {
      const product = this.currentProduct;
      let index = this.products.findIndex((p) => p.id == product.id);
      this.showCurrentProduct = index >= 0 ? false : true;
    } else {
      this.showCurrentProduct = false;
    }
  }

  public handleClose() {
    this.$emit("close");
  }

  public handleCloseMobile($event) {
    if ($event.target.id === "comparison" && window.innerWidth < 1270) {
      this.$emit("close");
    }
  }

  get emptyProducts() {
    let emptyList: any[] = [];
    for (let i = this.products.length; i < 3; i++) {
      emptyList.push({});
    }
    if (this.showCurrentProduct) emptyList.pop();
    return emptyList;
  }

  get hasProducts() {
    return this.products.length > 0;
  }

  get canCompare() {
    return this.products.length > 1 && this.products.length <= 3;
  }

  public addItem() {
    this.$emit("close");
  }
  public removeProduct(id) {
    this.$store.conversionWorld.removeCompareProduct(id);
  }
  public addProduct(product) {
    this.$store.conversionWorld.setCompareProduct(product, true);
  }

  public removeAll($event) {
    $event.preventDefault();
    this.$store.conversionWorld.removeAllCompareProducts();
  }

  public openProductComparison() {
    this.$emit("productCompare");
  }

  public getIconName(index) {
    if (index === 0 && !this.showCurrentProduct) {
      return "van-add-next";
    } else {
      let number = 4 + index - this.emptyProducts.length;
      switch (number) {
        case 2:
          return "van-add-second-inactive";
        case 3:
          return "van-add-third-inactive";
      }

      return "van-add-next";
    }
  }
}
